export default "__VITE_ASSET__Dr7p$Sh1__"